import React from 'react'

import AlreadyLoggedInAsClientUserModal from '@/components/layouts/ReferralInviteLayout/components/AlreadyLoggedInAsClientUserModal'
import AlreadyLoggedInAsCompanyUserModal from '@/components/layouts/ReferralInviteLayout/components/AlreadyLoggedInAsCompanyUserModal'
import { REFERRAL_INVITE_LAYOUT_PARAMS } from '@/components/layouts/ReferralInviteLayout/constants'
import { useHasMultipleReferralInvites } from '@/components/layouts/ReferralInviteLayout/hooks/useHasMultipleReferralInvites'
import HRMessage from '@/components/misc/HRMessage'
import { useClaimReferralModal } from '@/components/misc/ReferralDetails/hooks/useClaimReferralModal'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useIsAuthenticatedClient } from '@/hooks/useIsAuthenticatedClient'
import { useIsCompanyUser } from '@/hooks/useIsCompanyUser'
import { buildUrlWithQueryParams } from '@/lib/helpers/helperFunctions'
import authService from '@/lib/services/authService'

const ClaimReferralModal: React.FC = () => {
  const isCompanyUser = useIsCompanyUser()
  const isAuthenticatedClient = useIsAuthenticatedClient()
  const claimReferralModal = useClaimReferralModal()
  const hasMultipleInvites = useHasMultipleReferralInvites()

  if (isCompanyUser) {
    return <AlreadyLoggedInAsCompanyUserModal />
  }

  if (isAuthenticatedClient) {
    return <AlreadyLoggedInAsClientUserModal />
  }

  return (
    <>
      <Dialog
        onHide={claimReferralModal.hide}
        open={claimReferralModal.isShowing}
      >
        <DialogContent className="p-8">
          <DialogHeader>
            <DialogTitle className="text-xl">
              Create your free account or login to access the referral
            </DialogTitle>
          </DialogHeader>

          <DialogBody>
            <p className="text-md mb-4">
              To access your {hasMultipleInvites ? 'referrals' : 'referral'},
              please create your free account.
            </p>

            <Button
              variant="success"
              className="w-full"
              onClick={() => authService.registerAsCompanyUser()}
              size="lg"
            >
              Create account
            </Button>

            <HRMessage message="Or" className="my-4" />

            <p className="text-md mb-4">
              If you already have an account, you can login to claim the
              referral for an existing company.
            </p>

            <Button
              variant="primary"
              className="w-full"
              size="lg"
              onClick={() =>
                authService.signInAsCompanyUser(
                  buildUrlWithQueryParams(window.location.href, {
                    [REFERRAL_INVITE_LAYOUT_PARAMS.showClaimReferralModal]:
                      'true',
                  }),
                )
              }
            >
              Already have an account? Login
            </Button>
          </DialogBody>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ClaimReferralModal
